import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8 12c0 6 4 10 4 10s4-4 4-10-4-10-4-10-4 4-4 10Z"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21 15H3M21 9H3"
    }, null, -1)
  ])]);
}
const Globe02StrokeRoundedIcon = { render };
export {
  Globe02StrokeRoundedIcon as default,
  render
};
//# sourceMappingURL=globe-02-stroke-rounded.svg.js.map
